import React from "react";
import styled from "styled-components";
import { P, GridRow, Icon } from "notes";

export const FormMessage = ({
  content = "",
  type = "error",
  active = true,
  ...props
}) => {
  let color = type === "error" ? "red" : type === "info" ? "blue" : "green";
  return (
    active && (
      <ErrorMessageContainer yCenter color={color} {...props}>
        {type === "error" && <ErrorIcon form name="Error" />}
        {type === "success" && <SuccessIcon badge name="FacebookVerified" />}
        <Message color={color}>{content}</Message>
      </ErrorMessageContainer>
    )
  );
};

const ErrorMessageContainer = styled(GridRow)`
  background-color: ${(props) => props.theme.palette[props.color].lightest};
  border: 1px solid ${(props) => props.theme.palette[props.color].lighter};
  min-height: 54px;
  padding: 16px 24px;
  width: 100%;
  @media only screen and ${(props) => props.theme.media.small} {
    padding: 12px;
  }
`;

const Message = styled(P)`
  color: ${(props) =>
    props.color !== "info"
      ? props.theme.palette[props.color].primary
      : props.theme.palette.black};
`;

const ErrorIcon = styled(Icon)`
  display: inline-flex;
  flex-shrink: 0;
  margin-right: 16px;
  position: relative;
  width: 16px;
  @media only screen and ${(props) => props.theme.media.small} {
    display: none;
  }
`;

const SuccessIcon = styled(ErrorIcon)`
  path {
    fill: ${(props) => props.theme.palette.green.primary};
  }
`;
